import Axios from "axios";

export { GraphQLServer } from "./axiosGraphQL";
export { FileServer } from "./axiosREST";

Axios.defaults.baseURL = process.env.VUE_APP_API_URL;
Axios.defaults.headers.common["Accept-Language"] = localStorage.getItem("locale") || "en";
